import { BottomSheet } from './BottomSheet';
import { MessageCircle, Send, Mail } from 'lucide-react';

// Замени на реальные контакты поддержки (те же, что и в SupportModal.jsx).
const SUPPORT_WHATSAPP = "77779702298"; // международный формат, без "+", пробелов и скобок
const SUPPORT_TELEGRAM = "rzamaldinov"; // без "@"
const SUPPORT_EMAIL = "zamaldinov.raphael@gmail.com";

const SUPPORT_CHANNELS = [
  {
    key: 'whatsapp',
    label: `WhatsApp (+${SUPPORT_WHATSAPP})`,
    icon: <MessageCircle size={20} />,
    color: '#25D366',
    action: () => {
      const text = encodeURIComponent("Здравствуйте! У меня вопрос по приложению Атырау Жарык.");
      window.open(`https://wa.me/${SUPPORT_WHATSAPP}?text=${text}`, "_blank");
    }
  },
  {
    key: 'telegram',
    label: `Telegram (@${SUPPORT_TELEGRAM})`,
    icon: <Send size={20} />,
    color: '#3b82f6',
    action: () => {
      window.open(`https://t.me/${SUPPORT_TELEGRAM}`, "_blank");
    }
  },
  {
    key: 'email',
    label: `Почта (${SUPPORT_EMAIL})`,
    icon: <Mail size={20} />,
    color: '#8b5cf6',
    action: () => {
      const subject = encodeURIComponent("Вопрос по приложению Атырау Жарык");
      window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}`;
    }
  }
];

export function SupportSheet({ onClose }) {
  return (
    <BottomSheet title="Поддержка" onClose={onClose} open={true} modal={true}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {SUPPORT_CHANNELS.map((channel) => (
          <button
            key={channel.key}
            onClick={() => { channel.action(); onClose(); }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
              padding: '14px 16px',
              borderRadius: '12px',
              border: 'none',
              background: '#f5f5f5',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: 500,
              color: '#1a1a1a',
              width: '100%',
              textAlign: 'left'
            }}
          >
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '10px',
              background: channel.color + '20',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: channel.color,
              flexShrink: 0
            }}>
              {channel.icon}
            </div>
            {channel.label}
          </button>
        ))}
      </div>
    </BottomSheet>
  );
}
